import { RouteSheet } from '@/components/route-sheet';
import { useGetMatchedRoute } from '@/hooks/routing';
import { useI18n } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute, useLocation } from '@tanstack/react-router';

export const Route = createFileRoute('/(tv)/tv/$id/(pins)/_sheet')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { id } = Route.useParams();
  const match = useGetMatchedRoute();
  const { state } = useLocation();
  let hasBack = false;
  let backAsRouterNavigateBack = false;
  let title = '';
  let subtitle: string | undefined;
  const { t } = useI18n();
  switch (match.routeId) {
    case '/(tv)/tv/$id/(pins)/_sheet/pins/(pins)/':
      hasBack = false;
      backAsRouterNavigateBack = false;
      title = t('Pins.Title');
      break;
    case '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/':
      hasBack = true;
      backAsRouterNavigateBack = false;
      title = t('Pins.ChangePin.Title', { type: t(`Pins.Type.${match.params.pin}`) });
      break;
    case '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/contact-selection/':
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('Common.ContactValidation.ContactSelection.SheetTitle');
      break;
    case '/(tv)/tv/$id/(pins)/_sheet/pins/$pin/code-input/': {
      const { contactType, targetId } = (state ?? {}) as {
        contactType?: string;
        targetId?: string;
      };
      hasBack = true;
      backAsRouterNavigateBack = true;
      title = t('Common.ContactValidation.CodeInput.SheetTitle');
      if (contactType && targetId) {
        const descriptionKey =
          contactType === 'Sms'
            ? 'Common.ContactValidation.CodeInput.Description.Phone'
            : 'Common.ContactValidation.CodeInput.Description.Email';
        subtitle = t(descriptionKey, { contact: targetId });
      }
      break;
    }
  }

  return (
    <RouteSheet
      onClose={() => navigate({ to: '/tv/$id', params: { id } })}
      options={{ hasBack, backAsRouterNavigateBack, title, subtitle }}
    />
  );
}
